import { takeLatest, put } from "redux-saga/effects";
import { ApiCall } from "../api";
import {
  DC_CANCELAR_START,
  DC_GUARDAR_START,
  DC_SOLICITAR_START,
  DC_GETLISTADO_COMPLETE,
  DC_GETLISTADO_START,
  NOT_LOADING_COMPLETE,
  NSB_MENSAJE_ADD,
} from "../../const/actionTypes";
// import { addMinutes } from "date-fns";
import { jwtDecode } from "jwt-decode";

export function* GetDias({ payload }) {
  const p = {
    ...payload,
  };

  const token = {
    ...jwtDecode(p.Token),
    // opcion: "dias",
    // browser: JSON.stringify(window.navigator.userAgent),
    // conductorsol: p.Conductor,
  };
  // yield ApiCall("/api/Log/GrabarLog", "POST", JSON.stringify(token), p.Token);
  // let nbf = null;
  // try {
  //   nbf = new Date(token.nbf * 1000);
  // } catch {}
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
    // && (!nbf || (nbf && nbf >= addMinutes(new Date(), -3)))
  ) {
    yield put({ type: NOT_LOADING_COMPLETE, payload: true });
    const df = yield ApiCall(
      "/api/Dias/ObtenerFeriados",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    const dg = yield ApiCall(
      "/api/Dias/ObtenerGuardados",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    const ds = yield ApiCall(
      "/api/Dias/ObtenerSolicitudes",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    yield put({
      type: DC_GETLISTADO_COMPLETE,
      payload: {
        feriados: (df && df.Results) || [],
        guardados: (dg && dg.Results) || [],
        solicitudes: (ds && ds.Results) || [],
      },
    });
  }
  yield put({ type: NOT_LOADING_COMPLETE, payload: false });
}
export function* Solicitar({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });
  const p = {
    ...payload,
  };

  const token = {
    ...jwtDecode(p.Token),
  };
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
    // && (!nbf || (nbf && nbf >= addMinutes(new Date(), -3)))
  ) {
    const res = yield ApiCall(
      "/api/Dias/Solicitar",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    let mensaje;
    if (res && !res.Error) {
      mensaje = {
        mensaje: "Solicitud realizada con éxito.",
        variant: "success",
      };
      yield GetDias({ payload: { Conductor: p.Conductor, Token: p.Token } });
    } else {
      mensaje = {
        mensaje:
          "Hubo un error al realizar la solicitud.\nIntente nuevamente mas tarde.",
        variant: "error",
      };
    }
    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  }
}
export function* Guardar({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });
  const p = payload;
  const token = {
    ...jwtDecode(p.Token),
  };
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
  ) {
    const res = yield ApiCall(
      "/api/Dias/GuardarFeriado",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    let mensaje;
    if (res && !res.Error) {
      mensaje = {
        mensaje: "Día guardado con éxito.",
        variant: "success",
      };
      yield GetDias({ payload: { Conductor: p.Conductor, Token: p.Token } });
    } else {
      mensaje = {
        mensaje:
          "Hubo un error al guardar el día.\nIntente nuevamente mas tarde.",
        variant: "error",
      };
    }
    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  }
}
export function* Cancelar({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });
  const p = payload;
  const token = {
    ...jwtDecode(p.Token),
  };
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
    // &&    (!nbf || (nbf && nbf >= addMinutes(new Date(), -3)))
  ) {
    const res = yield ApiCall(
      "/api/Dias/CancelarSolicitud",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    let mensaje;
    if (res && !res.Error) {
      mensaje = {
        mensaje: "Solicitud cancelada con éxito.",
        variant: "success",
      };
      yield GetDias({ payload: { Conductor: p.Conductor, Token: p.Token } });
    } else {
      mensaje = {
        mensaje:
          "Hubo un error al cancelar la solicitud.\nIntente nuevamente mas tarde.",
        variant: "error",
      };
    }
    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  }
}
export default function* dias() {
  yield takeLatest(DC_GETLISTADO_START, GetDias);
  yield takeLatest(DC_SOLICITAR_START, Solicitar);
  yield takeLatest(DC_GUARDAR_START, Guardar);
  yield takeLatest(DC_CANCELAR_START, Cancelar);
}
